import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";

export const SECTION_ICONS = {
  stock: Inventory2OutlinedIcon,
  orders: LocalShippingOutlinedIcon,
  po: ReceiptLongOutlinedIcon,
};

/** Red when something in the section must be done today, amber for this week, green when clear. */
export const sectionTone = (ui, summary) => {
  if (summary.today) return { fg: ui.danger, bg: ui.dangerBg };
  if (summary.count) return { fg: ui.warning, bg: ui.warningBg };
  return { fg: ui.positive, bg: ui.positiveBg };
};
